/**
 * Vertical type definitions for ClawFarm multi-vertical platform
 */

export enum Role {
  ADMIN = "admin",
  OWNER = "owner",
  MEMBER = "member",
  AGENT_MANAGER = "agent_manager",
  AGENT_USER = "agent_user",
  BILLING_CONTACT = "billing_contact",
  VIEWER = "viewer",
  PLATFORM_ADMIN = "platform_admin",
}

export interface VerticalTheme {
  primaryColor?: string;
  logo?: string;
  favicon?: string;
}

export interface Vertical {
  id: string;
  name: string;
  displayName: string;
  description: string;
  domain: string;
  theme: VerticalTheme;
  navigation: string[];
  terminology: Record<string, string>;
  enabledFeatures: string[];
  isActive: boolean;
}

export interface NavigationItem {
  id: string;
  label: string;
  icon: string;
  href: string;
  roles: Role[];
  featureFlag?: string;
  vertical?: string;
  children?: NavigationItem[];
  position?: 'main' | 'user-menu';
}

export interface VerticalContextValue {
  vertical: Vertical;
  setVertical: (v: Vertical) => void;
  terminology: Record<string, string>;
  isVertical: (id: string) => boolean;
}
